import React from "react";
import SearchForm from "./SearchForm";

const OviHeader = (props) => {
  return (
    <React.Fragment>
      <div className="pt-3 pb-2 row">
        <div className="col-9">
          <h1 className="h2">
            <i className="fa-solid fa-envelope-open-text pe-2"></i>
            OVI Mail Details
          </h1>
        </div>
      </div>
      <p className="text-muted">
        Emails sent regarding OVI Status (limited to {props.maxRecords} results)
      </p>
      <SearchForm
        searchParams={props.searchParams}
        manufacturers={props.manufacturers}
        mailDetailNetworks={props.mailDetailNetworks}
      />
    </React.Fragment>
  );
};

export default OviHeader;
